module.exports = __webpack_public_path__ + "static/media/art45.d8f00f9b.jpg";